var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilepayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121,
    height: 130,
    viewBox: "0 0 121 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "76.994%",
    cy: "40.282%",
    r: "33.952%",
    fx: "76.994%",
    fy: "40.282%",
    gradientTransform: "matrix(-.39276 -.70227 .91964 -.29993 .702 1.064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1D275A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.08%",
    stopColor: "#4960DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M50.2228988,5.87615825 C49.5826589,5.87615825 48.9349527,5.99792683 48.3096455,6.26019762 L8.96195838,22.6165281 C7.72254357,23.1317029 6.75565069,24.1002314 6.24420542,25.3441443 C5.72902698,26.5861839 5.72902698,27.9556121 6.24420542,29.1995249 L43.8130336,120.228096 C44.8732559,122.796476 47.8224659,124.019782 50.3703593,122.955712 L89.7180464,106.597508 C92.2771393,105.533438 93.4960216,102.581019 92.4376659,100.012638 L54.8688377,8.98594048 C54.0680712,7.04700999 52.1940163,5.87615825 50.2228988,5.87615825 M48.4664389,129.214617 C44.1956843,129.214617 40.1358541,126.676211 38.4017933,122.478005 L0.83296515,31.4475603 C-0.27765505,28.755538 -0.27765505,25.7881313 0.83296515,23.0942356 C1.94545194,20.4003399 4.03603114,18.3021736 6.72018551,17.1875228 L46.0678726,0.829318904 C51.6041743,-1.46929724 57.9804409,1.17401766 60.2782114,6.73603177 L97.8470396,97.7646029 C100.13921,103.326617 97.4998541,109.724151 91.9616858,112.026514 L52.6139987,128.384718 C51.2569888,128.9486 49.8495811,129.214617 48.4664389,129.214617"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "21.005%",
    x2: "71.275%",
    y1: "100%",
    y2: "70.933%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3B50CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: "61.725%",
    cy: "52.493%",
    r: "38.248%",
    fx: "61.725%",
    fy: "52.493%",
    gradientTransform: "matrix(0 1 -1.6373 0 1.477 -.092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E54B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.679%",
    stopColor: "#4B63DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5A78FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M83.2787576,66.8062216 C72.0433827,71.4701396 62.6641088,77.916661 56.519967,85.6749094 L40.6853375,47.3246471 C47.4034544,39.2169786 56.2068897,33.1217459 67.4422646,28.4578279 C78.6813667,23.7939098 90.0304185,21.5254817 99.6724537,22.8428143 L115.508947,61.191208 C105.4942,60.141079 94.5159961,62.1441721 83.2787576,66.8062216"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A78FF",
    d: "M88.6173422,78.9060968 C76.4160159,78.9042121 65.2506336,81.282616 56.5853544,86.1336551 L56.5909643,47.023801 C65.9238102,42.0672225 76.4216257,39.7924733 88.622952,39.794358 C100.824278,39.7962426 112.215923,42.074761 120.65307,47.0332241 L120.64746,86.1430783 C111.765268,81.2882698 100.818669,78.9079814 88.6173422,78.9060968"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilepayLogo);
export default __webpack_public_path__ + "static/media/mobilepay-logo.ccb8ecee6fbd1cd46d9702b605dbee86.svg";
export { ForwardRef as ReactComponent };